var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgFilterAlt = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.71,
    height: 15.785,
    viewBox: "0 0 16.71 15.785",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "filtrar_1_",
    "data-name": "filtrar (1)",
    d: "M11.812,23.785a.619.619,0,0,1-.619-.619V17.214L5.455,10.9A1.736,1.736,0,0,1,6.739,8H19.98a1.736,1.736,0,0,1,1.284,2.9l-5.738,6.311V20.69a.619.619,0,0,1-.232.483l-3.1,2.476A.619.619,0,0,1,11.812,23.785ZM6.739,9.238a.5.5,0,0,0-.368.833l5.9,6.5a.619.619,0,0,1,.161.405v4.9l1.857-1.5v-3.4a.619.619,0,0,1,.161-.418l5.9-6.5a.5.5,0,0,0-.368-.82Z",
    transform: "translate(-5.004 -8)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFilterAlt, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/filter_alt.ac805ce5.svg";
export { ForwardRef as ReactComponent };